/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { UsersIcon } from "../../../../components/IconsSVG";
import AdminDropdown from "../../../../partials/content/CustomDropdowns/AdminDropdown";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "./Datatable";
import {
	StyledTableCell,
	StyledTableRow
} from "../../../../partials/datatable/styles";
import { MutantApiService } from "../../../../services/MutantApiService";
import Loading from "../../../home/components/Loading";
import { Modal } from "react-bootstrap";
import { StyledModal } from "../../../auth/ForgotPassword/style";
import { Container } from "react-bootstrap";
import { Button } from "@material-ui/core";
import { CustomAudioPlayer } from "./CustomAudioPlayer";
import store from "../../../../store/store";

const WarnningModal = ({ open, setOpen, onAcceptCallback }) => {
	const onAccept = () => {
		setOpen(false);
		onAcceptCallback();
	};

	return (
		<>
			<StyledModal
				show={open}
				onHide={() => setOpen(false)}
				size="md"
				centered
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
			>
				<Modal.Body>
					<Container className="d-flex flex-column justify-content-end">
						<div className="forgot-subtitle">
							Esta operação pode levar algumas horas dado o tamanho do projeto e
							quantidade de arquivos. Reunimos todos os arquivos e compactamos
							em um único arquivo zip. Assim que o arquivo estiver compactado o
							botão para fazer o download ficará ativo novamente.
							<br />
							<br />
							Enquanto a compressão estiver em andamento o botão para novas
							requisições se encontrará desabilitado.
						</div>

						<Button
							variant="contained"
							className={`kt-button-warning ml-auto mt-3`}
							style={{ color: "#fff" }}
							onClick={onAccept}
						>
							Entendi
						</Button>
					</Container>
				</Modal.Body>
			</StyledModal>
		</>
	);
};

export const getStatusTranslation = status => {
	switch (status) {
		case "ENQUEUED":
			return "ADICIONADO A FILA";

		case "PROCESSING":
			return "PROCESSANDO";

		case "PROCESSED":
			return "PROCESSADO";

		case "FAILED":
			return "FALHA NO PROCESSAMENTO";
		case "EXPIRED":
			return "EXPIRADO";

		default:
			return "STATUS DESCONHECIDO";
	}
};

export default function PromptsListing(props) {
	const api = new MutantApiService();
	const { idProject } = useParams();

	const [prompts, setPrompts] = useState([]);
	const [inputSearch, setInputSearch] = React.useState("");
	const [reload, setReload] = useState(false);
	const [loading, setLoading] = useState(true);
	const [project, setProject] = useState();
	const [open, setOpen] = useState(false);

	const [reason, setReason] = React.useState("");

	const handleChangeReason = event => {
		setReason(event.target.value);
	};

	useEffect(() => {
		setLoading(false);
		(async () => {
			try {
				const project = await api.makeHttpRequest({
					method: "GET",
					url: `/projects/${idProject}`
				});

				setProject(project);
			} catch (e) {
				console.log("Falha ao obter metadados do projeto");
			}
		})();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	const hadleInvalidation = async function(obj) {
		try {
			setLoading(true);

			await api.makeHttpRequest({
				method: "PATCH",
				url: `/prompts/${obj.id}/invalidate`,
				data: {
					reason
				}
			});

			setLoading(false);

			await Swal.fire({
				title: "Sucesso!",
				text: "Status alterado com sucesso.",
				icon: "success",
				cancelButtonText: "Sair"
			});
		} catch (e) {
			setLoading(false);
			await Swal.fire("Erro!", "Erro ao alterar status.", "error");
		} finally {
			setReload(!reload);
		}
	};

	const handleConfirmDelete = async id => {
		try {
			const reqBase = { method: "DELETE", url: `/prompts/${id}/` };

			await api.makeHttpRequest(reqBase);
			setReload({ reload: !reload });
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao remover item, tente mais tarde",
				"error"
			);
		}
	};

	window.setPageTitle("Listagem de prompts");

	const headRows = [
		{ label: "NOME", align: "left" },
		{ label: "TEXTO/ARQUIVO", align: "left" },
		{ label: "VOZ", align: "left" },
		{ label: "STATUS", align: "left" },
		{ label: "OUVIR", align: "left" },
		{ label: "AÇÕES", align: "center" }
	];

	const formatRow = prompt => {
		let crudActions = ["edit", "delete", "toggle"];

		const getStatusColor = status => {
			switch (status) {
				case "ENQUEUED":
					return "#A3A3A3";

				case "PROCESSING":
					return "#00b300";

				case "PROCESSED":
					return "#1F7A1F";

				case "FAILED":
					return "#FFA31A";

				case "EXPIRED":
					return "#bf4c04";

				default:
					return "#000000";
			}
		};

		return (
			<StyledTableRow
				hover
				tabIndex={-1}
				key={prompt.id}
				style={{
					backgroundColor: prompt.invalidated && "rgb(245, 203, 43, 0.25)"
				}}
			>
				<StyledTableCell scope="row" width="15%" align="left">
					{prompt.name}
				</StyledTableCell>
				<StyledTableCell scope="row" width="25%" align="left">
					<div dangerouslySetInnerHTML={{ __html: prompt.text }} />
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="left">
					{prompt.speaker}
				</StyledTableCell>
				<StyledTableCell
					scope="row"
					width="10%"
					style={{ color: getStatusColor(prompt.status) }}
					align="left"
				>
					{getStatusTranslation(prompt.status)}
				</StyledTableCell>
				<StyledTableCell scope="row" width="25%" align="left">
					{prompt.path && (
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}
						>
							{/* <audio controls>
                <source
                  name={`${prompt.name}.wav`}
                  src={prompt.path}
                  type="audio/wav"
                />
              </audio> */}
							<CustomAudioPlayer
								src={prompt.path}
								fileName={`${prompt.name}.wav`}
								prompt={prompt}
							/>
						</div>
					)}
					{!prompt.path && (
						<audio controls>
							<source src={null} type="audio/wav" />
						</audio>
					)}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="center">
					<CrudActions
						onConfirmChangeStatus={hadleInvalidation}
						onConfirmDelete={handleConfirmDelete}
						setReason={handleChangeReason}
						actions={crudActions}
						module="prompts"
						reason={reason}
						id={prompt.id}
						obj={prompt}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	};

	const history = useHistory();

	const handleSetRows = async (rows) => {
		const updatedPrompts = [];
	
		for (const prompt of rows) {
			try {
				const response = await fetch(prompt?.path, { method: 'GET' });
				if (!response.ok) {
					updatedPrompts.push({ ...prompt, status: 'EXPIRED' });
				} else {
					updatedPrompts.push(prompt);
				}
			} catch (error) {
				console.error('Error checking file existence for', prompt?.path, error);
				updatedPrompts.push(prompt);
			}
		}
	
		setPrompts(updatedPrompts);
	};
	

	const [isDownloading, setIsDownloading] = useState(false);

	const [downloadProgress, setDownloadProgress] = useState(0);
	const [downloadingFileName, setDownloadingFileName] = useState("");
	
	const downloadZip = useCallback(async () => {
		const {
			auth: { authData }
		} = store.getState();
		const accessToken = authData?.accessToken;

		try {
			setIsDownloading(true);
			const url = `${process.env.REACT_APP_API_HOST}/api/projects/${idProject}/download`;
			window.open(url, "_blank");
		} catch (e) {
			Swal.fire(
				"Erro!",
				"Erro ao iniciar o download. Por favor, tente novamente.",
				"error"
			);
		} finally {
			setIsDownloading(false);
			setDownloadProgress(0);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [idProject]);

	const requestZipFile = async () => {
		try {
			const response = await api.makeHttpRequest({
				method: "GET",
				url: `${process.env.REACT_APP_API_HOST}/api/projects/${idProject}/zip`
			});

			setProject(response);

			setIsDownloading(false);
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Erro ao solicitar arquivo zip do projeto",
				"error"
			).then(() => {
				setIsDownloading(false);
			});
		}
	};

	
	return (
		<>
			<Loading isLoading={loading} />
			<WarnningModal
				open={open}
				setOpen={setOpen}
				onAcceptCallback={requestZipFile}
			/>{" "}
			{isDownloading && (
				<div
					style={{
						padding: "10px",
						border: "2px solid #15025c",
						borderRadius: "5px",
						margin: "10px 0",
						backgroundColor: "#f5f5f5",
						boxShadow: "0 0 5px #15025c"
					}}
				>
					<div>Baixando {downloadingFileName}</div>
					<div style={{ width: "100%", backgroundColor: "#ddd" }}>
						<div
							style={{
								height: "10px",
								width: `${downloadProgress}%`,
								backgroundColor: "#15025c"
							}}
						></div>
					</div>
				</div>
			)}
			<Datatable
				title="Prompts"
				icon={UsersIcon}
				endpoint={`projects/${idProject}/prompts`}
				className="h-100"
				headRows={headRows}
				formatRow={formatRow}
				setInputSearch={setInputSearch}
				inputSearch={inputSearch}
				rows={prompts}
				setRows={handleSetRows}
				idProject={idProject}
				reloadEvery={60000}
				reload={reload}
				placeholderSearch="Filtre por nome, modelo ou texto do prompt"
				mobile={AdminDropdown}
				width={props.width}
				hiddenReload
				notPaginated
				users
				buttons={[
					{
						label: "Adicionar",
						onClick: () => {
							history.push(`/dashboard/projects/${idProject}/prompts/new`, {
								project: idProject
							});
						},
						icone: "add"
					},
					{
						label: project?.isPacking ? "Empacotando zip" : "Solicitar zip",
						disabled: prompts.length === 0 || project?.isPacking,
						onClick: () => setOpen(true),
						icone: null
					},
					{
						label: project?.isPacking ? "Gerando novo link" : "Baixar zip",
						disabled:
							prompts.length === 0 || !project?.zipPath || project?.isPacking,
						loading: isDownloading,
						onClick: downloadZip,
						icone: "download"
					}
				]}
			/>
		</>
	);
}

export function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export const orderById = (a, b) => {
	if (a.id < b.id) {
		return -1;
	}
	if (a.id > b.id) {
		return 1;
	}
	return 0;
};
